"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../style/injectSheet"));
var _excluded = ["classes", "className", "component", "target", "theme", "url"];
/*:: // 

import { type ElementType } from 'react';*/
/*:: import { type InjectSheetProvidedProps } from '../style/ThemeTypes';*/
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Style = {
  root: {
    height: 'auto',
    padding: 0,
    minWidth: 0,
    fontSize: 'inherit',
    userSelect: 'auto'
  }
};
/*:: type Props = InjectSheetProvidedProps & {
  /**
   * Component to be used as the heading
   *-/
  component: ElementType,
  /**
   * The link's target window
   *-/
  target: string,
  /**
   * The link's url
   *-/
  url: string
};*/
function MarkdownLink(props /*: Props*/) {
  var classes = props.classes,
    classNameProp = props.className,
    _props$component = props.component,
    Component = _props$component === void 0 ? 'button' : _props$component,
    target = props.target,
    theme = props.theme,
    url = props.url,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  var className = (0, _classnames.default)(classes.root, classNameProp);
  var componentProps = Object.assign({}, other);
  delete componentProps.referenceType;
  return /*#__PURE__*/_react.default.createElement(Component, _objectSpread(_objectSpread({}, componentProps), {}, {
    className: className,
    href: url,
    target: target
  }));
}
MarkdownLink.displayName = 'MarkdownLink';
MarkdownLink.defaultProps = {
  component: 'a',
  target: '_blank'
};
var _default = exports.default = (0, _injectSheet.default)(Style)(MarkdownLink);
//# sourceMappingURL=Link.js.map